<template>
<div>
    <div class="contain">
        <div class="title">{{notice.title}}</div>
        <div class="data">日期：{{notice.createTime}}</div>
        <div class="text">
            <p class="textimg" v-html="notice.context"></p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            notice: {}
        }
    },
    mounted() {
        this.notice = this.$route.query.notice;
        console.log(this.notice)

        window.onload = function () {
            //获取图片元素
            var imgs = document.getElementsByTagName("img");
            //获取div元素   
            // var contentLeft = document.getElementById("col-md-7");
            //使用js设置图片元素宽度的变化    
            for (var i = 0; i < imgs.length; i++) {
                imgs[i].style["max-width"] = 40 + "px";
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.textimg >>> img {
    display: block;
    max-width: 100%;
}
.textimg >>> p{
    display: block;
    max-width: 100%;
}

.text {
    padding-top: 20px;
}

.contain {
    padding: 20px;
}

.title {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    padding-bottom: 20px;
}

.text {
    padding-top: 20px;
    // text-indent: 2em;
    font-size: 28px;

}

.data {
    border-bottom: 1px solid #2283e2;
    text-align: center;
    padding-bottom: 30px;

}

.paging {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
}
</style>
